import type { PageMeta } from "@/api/types";

type PaginationProps = {
  meta?: PageMeta;
  pageSizeOptions?: readonly number[];
  onPageChange(page: number): void;
  onPageSizeChange?(pageSize: number): void;
};

export function Pagination({
  meta,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) {
  if (!meta || meta.total === 0) return null;
  const pages = Array.from({ length: meta.totalPages }, (_, index) => index + 1);
  const sizes = [...new Set([...(pageSizeOptions ?? []), meta.pageSize])].sort(
    (left, right) => left - right,
  );
  const first = (meta.page - 1) * meta.pageSize + 1;
  const last = Math.min(meta.total, meta.page * meta.pageSize);
  return (
    <nav className="pagination" aria-label="Paginación">
      <div className="pagination__summary">
        <span>
          <strong>{first}–{last}</strong> de {meta.total} registros · página {meta.page} de {meta.totalPages}
        </span>
        {pageSizeOptions?.length && onPageSizeChange ? (
          <label className="pagination__size-picker">
            <span>Mostrar</span>
            <select
              aria-label="Registros por página"
              value={meta.pageSize}
              onChange={(event) => onPageSizeChange(Number(event.target.value))}
            >
              {sizes.map((size) => <option key={size} value={size}>{size}</option>)}
            </select>
            <span>por página</span>
          </label>
        ) : null}
      </div>
      <div className="pagination__controls">
        <button type="button" className="button button--small" disabled={meta.page === 1} onClick={() => onPageChange(1)}>
          Primera
        </button>
        <button type="button" className="button button--small" disabled={!meta.hasPreviousPage} onClick={() => onPageChange(meta.page - 1)}>
          Anterior
        </button>
        <label className="pagination__page-picker">
          <span>Página</span>
          <select aria-label="Ir a página" value={meta.page} onChange={(event) => onPageChange(Number(event.target.value))}>
            {pages.map((page) => <option key={page} value={page}>{page}</option>)}
          </select>
          <span>de {meta.totalPages}</span>
        </label>
        <button type="button" className="button button--small" disabled={!meta.hasNextPage} onClick={() => onPageChange(meta.page + 1)}>
          Siguiente
        </button>
        <button type="button" className="button button--small" disabled={meta.page === meta.totalPages} onClick={() => onPageChange(meta.totalPages)}>
          Última
        </button>
      </div>
    </nav>
  );
}
